import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { Integration } from "model/integration";
import { Card } from "../card";
import { Tag } from "component/shared/tag";
import { connectedChip, connectionLostChip } from "../status-chips";

interface Props {
	integration: Integration;
	loading: boolean;
	onViewIntegration: () => void;
}

export function FacebookCard({ integration, loading, onViewIntegration }: Props) {
	let statusChip: React.ReactNode;
	if (integration.errored) {
		statusChip = connectionLostChip;
	} else if (loading) {
		statusChip = <Tag label="Loading..." variant="neutral" />;
	} else {
		statusChip = connectedChip;
	}

	return (
		<Card
			integration={integration}
			deletable={true}
			content={
				<Mui.Box display="flex" alignItems="center" style={{ minHeight: 32 }}>
					{statusChip}
				</Mui.Box>
			}
			actions={
				<Mui.Button variant="text" size="small" color="primary" onClick={onViewIntegration}>
					View Details <Icons.ChevronRight size={16} style={{ marginLeft: 4 }} />
				</Mui.Button>
			}
		/>
	);
}
